<template>
  <div class="col-sm-12 nopads" @click.stop="">
    <div class="col-sm-12 editor-form">
        <h2 class="editor-header">{{ deviceUpdate.imei ? $t('tracking_devices.edit') : $t('tracking_devices.add')}}</h2>
      <div class="row">
        <div class="col-sm-6">
          <span class="span-title">
            {{ $t('tracking_devices.imei') }}
          </span>
            <input
                id="imei"
                v-model="imei"
                type="text"
                class="form-control form-control-sm"
                :placeholder="$t('tracking_devices.hint_imei')"
                :disabled="deviceUpdate.imei !== undefined"
            />
        </div>
        <div class="col-sm-6">
          <span class="span-title">
            {{ $t('tracking_devices.vehicle') }}
          </span>
            <select
                id="vehicle"
                v-model="vehicle"
                class="form-select form-select-sm"
                :disabled="!vehicles || vehicles.length < 1"
            >
                <option :value="null" disabled>
                    {{ $t('tracking_devices.select_vehicle') }}
                </option>
                <option
                    v-for="v in vehicles"
                    :key="v.id"
                    :value="v.id"
                >
                    {{ v.license_plate }} - {{ v.make }} - {{ v.vehicle_model }}
                </option>
            </select>
        </div>
      </div>
      <div class="row">
        <span class="hint-text pl-2">
          {{ $t('tracking_devices.hint_contract') }}
        </span>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <open-contract-filter
            :to="toDate"
            :from="fromDate"
            :contract="contract"
            :show-company="false"
            :show-only-my-contracts-option="true"
            style="margin-left: -2px; margin-right: -3px;"
            @loading="loading=true"
            @loading-completed="loading=false"
            @contract-selected="setContract"
          />
        </div>
        <div class="col-sm-6" style="margin-top: -5px">
            <contract-order-multiselect
                v-if="contract && order"
                ref="orderFilter"
                :contract-ids="contract ?  [contract.id] : []"
                :single-mode="true"
                :pre-selected-order="order.id"
                @orders-selected="setOrder"
            />
        </div>
      </div>
      <div class="row">
        <span class="hint-text pl-2">
          {{ $t('tracking_devices.hint_user') }}
        </span>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <span class="span-title">
            {{ $t('tracking_devices.user') }}
          </span>
            <select
                id="vehicle"
                v-model="user"
                class="form-select form-select-sm"
                :disabled="!users || users.length < 1"
            >
                <option :value="null">
                    {{ $t('tracking_devices.select_user') }}
                </option>
                <option
                    v-for="u in users"
                    :key="u.id"
                    :value="u.id"
                >
                    {{ u.last_name }}, {{ u.first_name }}
                </option>
            </select>
        </div>
      </div>

      <div class="col-sm-12 button-container">
        <button class="btn btn-secondary form-button" @click.stop="$emit('close')">
            {{ $t('common.cancel') }}
        </button>
        <button class="btn btn-success form-button" :disabled="loading" @click.stop="submitDevice">
            {{ $t('common.save') }}
        </button>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {workManagementHelper} from '../mixins/WorkManagementMixin'
import OpenContractFilter from "@/components/contract/OpenContractFilter";
import {inject} from "vue";
import ContractOrderMultiselect from "../order/ContractOrderMultiselect.vue";

export default {
    name: 'TrackingDeviceEditor',
    components: {ContractOrderMultiselect,OpenContractFilter},
    mixins: [restApi, workManagementHelper],
    props: {
        device: {
            type: Object,
            default: null
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            vehicle: null,
            contract: null,
            order: null,
            vehicles: [],
            user: null,
            users: [],
            imei: null,
            deviceUpdate: this.jsonToItem(this.device),
            colors: ''
        }
    },
    computed: {
        fromDate() {
            let d = new Date()
            return d.toISOString()
        },
        toDate() {
            let d = new Date()
            return d.toISOString()
        }
    },
    mounted: function () {
        if (this.deviceUpdate.imei) {
            this.vehicle = this.deviceUpdate.vehicle.id
            if (this.deviceUpdate.user) {
                this.user = this.deviceUpdate.user.id
            }
            this.imei = this.deviceUpdate.imei
            this.order = this.deviceUpdate.work_order
            this.contract = this.deviceUpdate.contract
        }
        this.fetchVehicles()
        this.fetchUsers()
    },
    methods: {
        setOrder(order) {
            this.order = order
        },
        fetchVehicles: function () {
            this.loading = true
            this.restFetch(this.vehicleUrl, this.handleVehicles)
        },

        handleVehicles: function (response) {
            if (response && response.data) {
                this.vehicles = response.data
            }
            this.loading = false
        },

        fetchUsers: function () {
            this.loading = true
            this.restFetch(this.userUrl, this.handleUsers)
        },

        handleUsers: function (response) {
            if (response && response.data) {
                this.users = response.data
            }
            this.loading = false
        },

        setContract(contract) {
            this.contract = contract
        },

        setDefaultValues: function () {
            if (!this.imei) {
                this.showAlert(this.$t('tracking_device.imei_missing'))
                return undefined
            }
            if (!this.vehicle) {
                this.showAlert(this.$t('tracking_device.vehicle_missing'))
                return undefined
            }
            let result = {imei: this.imei, vehicle: {id: this.vehicle}, harja_enabled: false}
            if (this.user) {
                result.user = {id: this.user}
            }
            if (this.contract) {
                result.contract = {id: this.contract.id}
            }
            if (this.order) {
                result.work_order = {id: this.order.id }
            }
            return result
        },

        submitDevice: function () {
            var json = this.setDefaultValues()
            if (json !== undefined) {
                if (!this.device.imei) {
                    this.restAdd(this.trackingDeviceUrl, json, this.success, this.fail)
                } else {
                    this.restUpdate(this.trackingDeviceUrl, json, this.success, this.fail)
                }
                this.loading = true
            }
        },

        success: function () {
            this.$emit('closeAndUpdate')
            this.loading = false
        },

        fail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        }

    }
}
</script>
